'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNowWallpaper = function MdNowWallpaper(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.6 21.6v11.8h11.8v3.2h-11.8q-1.3 0-2.3-0.9t-0.9-2.3v-11.8h3.2z m26.8 11.8v-11.8h3.2v11.8q0 1.3-0.9 2.3t-2.3 0.9h-11.8v-3.2h11.8z m0-30q1.3 0 2.3 0.9t0.9 2.3v11.8h-3.2v-11.8h-11.8v-3.2h11.8z m-5 10.7q0 1.1-0.8 1.8t-1.7 0.7-1.8-0.7-0.7-1.8 0.7-1.7 1.8-0.8 1.7 0.8 0.8 1.7z m-11.8 7.5l5 6.2 3.4-4.4 5 6.6h-20z m-10-15v11.8h-3.2v-11.8q0-1.3 0.9-2.3t2.3-0.9h11.8v3.2h-11.8z' })
        )
    );
};

exports.default = MdNowWallpaper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/now-wallpaper.js
// module id = 2596
// module chunks = 0